// extracted by mini-css-extract-plugin
export default {"container":"jV7Y9VTJVI","uplink":"tam3fnDZo3","downlink":"Zq635_SRNJ","policy":"mve3Cn5kgL","icon":"n8aPVaPCo9"};